module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('script', {
    attrs: {
      "id": _vm.editorID,
      "type": "text/plain"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e01250e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UE.vue
// module id = 1284
// module chunks = 169